/**
 * Created by h3 on 2018-09-24.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {FruitsLayerConfig} from "../../../../config/FruitsLayerConfig";
import {FruitsStrings} from "../../../../config/FruitsStrings";
import {FruitsTextStyles} from "../../../../config/FruitsTextStyles";
import {CountUpBit} from "../../../animationsbits/countup/CountUpBit";
import {FruitsGameAssets} from "../../../FruitsGameAssets";
import {FruitsGameConfig} from "../../../FruitsGameConfig";
import {FruitsGameModuleConfig} from "../../../FruitsGameModuleConfig";
import {FruitsSoundConfig} from "../../../FruitsSoundConfig";
import {FruitsParsedGameData} from "../../../server/data/FruitsParsedGameData";
import {FruitsHelper} from "../../../utils/FruitsHelper";
require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");

export class PreOutroScreenView extends BaseView {

    public static readonly ABORT_OUTRO_COUNT_UP:string = "preOutroScreenView_abortOutroCountUp";

    private _layer:ScalableLayer;
    private _backgroundImage:PIXI.TilingSprite;
    private _container:PIXI.Container;
    private _bgImageContainer:PIXI.Container;
    private _countUp:CountUpBit;
    private _totalWin:number;
    private _finalBonusWin:number;
    private _collectedScatterAfter:number;
    private _customEase:CustomEase;
    private _scattersArray:TimelineSprite[];
    private _orientation:Orientation;


    private _screenWidth:number;
    private _screenHeight:number;
    private _leftOffset:number;
    private _topOffset:number;

    private readonly _style:BitmapTextStyleOptions = {
        font : {name : "WinNumbersBM", size : 72},
        align : "center",
    };
    private _scatterContainer:PIXI.Container;
    private _parsedBonusPositions:string[];
    private _centerX:number;
    private _centerY:number;
    private _totalWinText:PIXI.Text;
    private _brightnessFilter:PIXI.filters.ColorMatrixFilter;
    private _isBigWin:boolean;
    private _highOrderLayer:ScalableLayer;

    protected _clickerContainer:PIXI.Container; // for add some other things on top.
    private _clicker:PIXI.Graphics;
    private _enabled:boolean = false;

    public get enabled():boolean {
        return this._enabled;
    }

    public set enabled(value:boolean) {
        if(value === this._enabled) {
            return;
        }

        this._enabled = value;

        if(this._clicker) {
            this._clicker.interactive = this._enabled;
            this._clicker.buttonMode = this._enabled;
        }

        if(this._enabled) {
            if(this._isResizeDirty) {
                this.onResize(this._resizeData);
            }
            if(this._clickerContainer.children.indexOf(this._clicker) === -1) {
                this._clickerContainer.addChild(this._clicker);
            }
        } else if(this._clickerContainer.children.indexOf(this._clicker) > -1) {
            this._clickerContainer.removeChild(this._clicker);
        }
    }

    constructor() {
        super(ResourcesGroupName.MAIN);
        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.BONUS_GAME_PRE_INTRO.name);
        this._highOrderLayer = StageManager.getLayer(FruitsLayerConfig.HIGH_ORDER_LAYER.name);

        this._countUp = new CountUpBit();

    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));

    }

    protected onGameDataParsed(data:FruitsParsedGameData):void {

        this._totalWin = data.totalWin;
        this._finalBonusWin = data.finalBonusWin;
        this._collectedScatterAfter = data.collectedScatterAfter;
        this._isBigWin = data.isBigWin;

        if(data.bonusOverlayPositionsAfter) {
            this._parsedBonusPositions = PreOutroScreenView.parseBonusPositions(data!.bonusOverlayPositionsAfter);

        }

    }

    protected initAnimations():void {

        this._clickerContainer = new PIXI.Container();
        this._layer.addChild(this._clickerContainer);

        this._clicker = new PIXI.Graphics();
        this._clicker.on('pointertap', () => this.endPreOutro());

        this._bgImageContainer = new PIXI.Container();
        this._bgImageContainer.alpha = 0;

        this._container = new PIXI.Container();

        this._scattersArray = [];

        this._brightnessFilter = new PIXI.filters.ColorMatrixFilter();

        this._scatterContainer = new PIXI.Container();

        this._layer.addChild(this._bgImageContainer);
        this._highOrderLayer.addChild(this._container);
        this._layer.addChild(this._scatterContainer);


        this.createGraphics();

        this._clickerContainer = new PIXI.Container();
        this._layer.addChild(this._clickerContainer);


    }

    private createGraphics() {
        this._backgroundImage = new PIXI.TilingSprite(
            GameResources.getTextures(FruitsGameAssets.BONUS_BG_LANDSCAPE)[0],
            GameConfig.instance.GAME_WIDTH,
            GameConfig.instance.GAME_HEIGHT
        );

        this._countUp.position.set(GameConfig.instance.GAME_WIDTH * 0.5, GameConfig.instance.GAME_HEIGHT * 0.45);

        this._customEase = CustomEase.create("custom", "M0,0 C0.126,0.382 0.173,1.232 0.396,1.182 0.536,1.15 0.53,0.84 0.696,0.874 0.807,0.896 0.962,1 1,1");

        this._bgImageContainer.addChild(this._backgroundImage);


        this._container.addChild(this._countUp);
        this.createTotalWinText();

    }


    protected onResize(resizeData:IResizeData):void {
        this._bgImageContainer.removeChild(this._backgroundImage);
        this._orientation = Orientation.LANDSCAPE;

        this._totalWinText.position.set(this._centerX, 150);

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._totalWinText.position.set(this._centerX, 120);
            this._orientation = Orientation.PORTRAIT;
        }

        this._screenWidth = resizeData.width / this._layer.scale.x;
        this._screenHeight = resizeData.height / this._layer.scale.y;
        this._leftOffset = -this._layer.x / this._layer.scale.x;
        this._topOffset = -this._layer.y / this._layer.scale.y;

        this._centerX = this._screenWidth / 2 + this._leftOffset;
        this._centerY = this._screenHeight / 2 + this._topOffset;

        if(this._countUp) {
            this._countUp.setMaxWidth(this._screenWidth);
        }

        this._backgroundImage = new PIXI.TilingSprite(
            GameResources.getTextures(FruitsGameAssets.BONUS_BG_LANDSCAPE)[0],
            this._screenWidth,
            this._screenHeight
        );

        this._backgroundImage.tileScale.y = this._screenHeight / 720;
        this._backgroundImage.anchor.set(0.5, 0.5);
        this._backgroundImage.position.set(this._centerX, this._centerY);

        this._bgImageContainer.addChild(this._backgroundImage);

        this.handleClicker();
    }

    private handleClicker() {
        if(!this._enabled) {
            this._isResizeDirty = true;
            return;
        }

        this._clicker.clear();
        this._clicker.beginFill(0xFF0000, 0);
        this._clicker.drawRect(this._leftOffset, this._topOffset, this._screenWidth, this._screenHeight);

        this._isResizeDirty = false;
    }


    private static parseBonusPositions(bonusOverlayPositionsAfter:boolean[][]):string[] {
        let parsedSymbols = ["X", "X", "X", "X"];
        for(let i = 0; i < bonusOverlayPositionsAfter.length; i++) {
            for(let j = 0; j < bonusOverlayPositionsAfter[i].length; j++) {
                let sym = bonusOverlayPositionsAfter[i][j] ? "S" : "X";


                parsedSymbols.push(sym);

            }
        }
        return parsedSymbols;
    }

    private createScatterSprites(bonusPositions:string[]):TimelineSprite[] {

        const scattersArray:TimelineSprite[] = [];

        for(let i:number = 0; i < bonusPositions.length; i++) {
            if(bonusPositions[i] === "S") {
                let symInd:[number, number] = FruitsHelper.translateReelIndex(i);
                let rectPos:number[] = FruitsHelper.getSymbolPosition(symInd[0], symInd[1], this._orientation, "BONUS_GAME");

                const scatter = this.getScatterTexture();
                scatter.anchor.set(0.5, 0.5);
                scatter.hide();
                scatter.position.set(rectPos[0], rectPos[1]);
                this._scatterContainer.addChild(scatter);
                scattersArray.push(scatter);
            }
        }

        return scattersArray;


    }

    private getScatterTexture():TimelineSprite {

        if(this._collectedScatterAfter >= 6 && this._collectedScatterAfter <= 8) {
            return new TimelineSprite(GameResources.getTextures("S_B_win"));
        } else if(this._collectedScatterAfter >= 9 && this._collectedScatterAfter <= 10) {
            return new TimelineSprite(GameResources.getTextures("S_C_win"));
        } else if(this._collectedScatterAfter >= 11 && this._collectedScatterAfter <= 12) {
            return new TimelineSprite(GameResources.getTextures("S_D_win"));
        } else {
            return new TimelineSprite(GameResources.getTextures("S_win"));
        }

    }

    private playScatterAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        this._scattersArray = this.createScatterSprites(this._parsedBonusPositions);

        this._scattersArray.forEach((sym) => {
            tl.add(sym.getAnimationAutoShowHide(true, false), 0);
            tl.add(() => sym.hide(), 1.5);

        });


        return tl;
    }

    private clearScatters():void {
        this._scattersArray.forEach((sym) => {
            TweenLite.to(sym, 0.25, {alpha : 0, onComplete : () => {sym.hide()}});

        });

    }

    private createTotalWinText() {

        this._totalWinText = new PIXI.Text(` ${Translation.translate(FruitsStrings.BONUS_WIN)} `, FruitsTextStyles.BONUS_OUTRO_TOT_WIN);
        this._totalWinText.anchor.set(0.5, 0.5);
        this._totalWinText.position.set(this._centerX, this._screenHeight * 0.2);
        this._totalWinText.alpha = 0;

        this._container.addChild(this._totalWinText);
    }

    public getAnimation():TimelineLite {
        this._countUp.scale.set(0.2, 0.2);

        const tl:TimelineLite = new TimelineLite();
        tl.add([
            TweenLite.to(this._bgImageContainer, 1, {alpha : 0.7}),
            this.playScatterAnimation()
        ]);
        tl.add([
            () => this._countUp.visible = true,
            this._countUp.getCountUpAnimation(0, this._finalBonusWin, 5),
            () => this.enabled = true,
            () => this.playParticles(),
            () => SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_COUNT_UP_GLITTER),
            () => FruitsGameModuleConfig.soundHandler.startCountUp(),
            TweenLite.to(this._countUp.scale, 2, {x : 1, y : 1})
        ]);
        tl.add([
            () => SlotGame.winFieldController.showWinField(),
            () => this.swapAmbientSound(),
            () => this.stopSounds(),
            () => this.enabled = false,
            () => this.stopParticles(),
            TweenLite.to(this._totalWinText, 0.5, {alpha : 1})
        ]);

        return tl;
    }

    private endPreOutro() {
        this.enabled = false;
        const tl:TimelineLite = new TimelineLite();
        this.stopParticles();
        tl.add(() => EventHandler.dispatchEvent(new GameEvent(PreOutroScreenView.ABORT_OUTRO_COUNT_UP)));
        tl.add([
            () => this._countUp.getCountUpAnimation(this._finalBonusWin, this._finalBonusWin, 0.001),
            () => this.stopSounds(),
            () => this.swapAmbientSound(),
            TweenLite.to(this._totalWinText, 0.25, {alpha : 1}),
            TweenLite.to(this._countUp.scale, 0.25, {x : 1, y : 1}),
            () => this.clearScatters(),
        ]);

    }

    private playParticles():void {
        if(this._isBigWin) {
            FruitsGameModuleConfig.particles.startBonusEmitter();
        }
    }

    private stopParticles():void {
        if(this._isBigWin) {
            FruitsGameModuleConfig.particles.getResetEmitters();
        }
    }

    private reset() {
        this._scatterContainer.removeChildren();
        this._countUp.scale.set(0.2, 0.2);
        this._countUp.visible = false;

        this._container.alpha = 1;
        this._bgImageContainer.alpha = 0;
        this._totalWinText.alpha = 0;

    }

    public fadeOutBackground():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            TweenLite.to(this._bgImageContainer, 0.5, {alpha : 0}),
            TweenLite.to(this._container, 0.5, {alpha : 0}),
        ]);

        tl.add(() => this.reset());

        return tl;
    }

    private stopSounds():void {
        SlotGame.sound.playEffect(FruitsSoundConfig.LIGHTNING_ENDS);
        SlotGame.sound.stopEffect(FruitsSoundConfig.LIGHTNING_COUNT_UP_GLITTER);
        FruitsGameModuleConfig.soundHandler.stopCountUp(false);
    }


    private swapAmbientSound():void {
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.playAmbience(FruitsSoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 0);
    }
}